export default {"src":"/_next/static/image/public/images/flags/flag_228.4b91b932ef96953622734aa0649b7f1a.svg","height":16,"width":24};